import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, FileText, Shield, RotateCcw, Building2 } from "lucide-react";
import { COMPANY } from "../lib/companyInfo";

export default function Footer() {
  return (
    <footer className="mt-16 pt-10 pb-8 border-t border-stone-200 text-sm text-stone-600 no-print" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-4 md:px-8 grid grid-cols-1 md:grid-cols-3 gap-8">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <div className="w-8 h-8 rounded-lg bg-slate-900 flex items-center justify-center">
              <Building2 className="w-4 h-4 text-orange-400" strokeWidth={2} />
            </div>
            <span className="font-display font-black text-slate-900">
              {COMPANY.brand}
            </span>
          </div>
          <p className="text-xs text-stone-500 leading-relaxed">
            Türkiye'deki oto galerilerin stok, satış, kiralama ve gider
            yönetimini tek panelden yürüten SaaS ürünü.
          </p>
        </div>

        <div>
          <div className="text-[11px] font-semibold uppercase tracking-widest text-stone-500 mb-3">
            İletişim & Firma
          </div>
          <div className="space-y-1.5 text-xs">
            <div className="text-slate-900 font-semibold">{COMPANY.name}</div>
            <div>VKN: <span className="num-tabular">{COMPANY.vkn}</span></div>
            <div className="flex items-start gap-1.5">
              <MapPin className="w-3.5 h-3.5 mt-0.5 shrink-0 text-stone-400" />
              <span>{COMPANY.address}</span>
            </div>
            <div className="flex items-center gap-1.5">
              <Phone className="w-3.5 h-3.5 text-stone-400" />
              <a href={`tel:${COMPANY.phoneHref}`} className="hover:text-orange-700 num-tabular">
                {COMPANY.phone}
              </a>
            </div>
            <div className="flex items-center gap-1.5">
              <Mail className="w-3.5 h-3.5 text-stone-400" />
              <a href={`mailto:${COMPANY.email}`} className="hover:text-orange-700">
                {COMPANY.email}
              </a>
            </div>
          </div>
        </div>

        <div>
          <div className="text-[11px] font-semibold uppercase tracking-widest text-stone-500 mb-3">
            Yasal
          </div>
          <ul className="space-y-2 text-xs">
            <li>
              <Link to="/mesafeli-satis-sozlesmesi" data-testid="footer-legal-msale" className="hover:text-orange-700 flex items-center gap-1.5">
                <FileText className="w-3.5 h-3.5" /> Mesafeli Satış Sözleşmesi
              </Link>
            </li>
            <li>
              <Link to="/iptal-iade" data-testid="footer-legal-refund" className="hover:text-orange-700 flex items-center gap-1.5">
                <RotateCcw className="w-3.5 h-3.5" /> İptal ve İade Koşulları
              </Link>
            </li>
            <li>
              <Link to="/gizlilik" data-testid="footer-legal-privacy" className="hover:text-orange-700 flex items-center gap-1.5">
                <Shield className="w-3.5 h-3.5" /> Gizlilik ve Güvenlik Politikası
              </Link>
            </li>
            <li>
              <Link to="/kullanici-sozlesmesi" data-testid="footer-legal-tos" className="hover:text-orange-700 flex items-center gap-1.5">
                <FileText className="w-3.5 h-3.5" /> Kullanıcı Sözleşmesi
              </Link>
            </li>
            <li>
              <Link to="/kvkk" data-testid="footer-legal-kvkk" className="hover:text-orange-700 flex items-center gap-1.5">
                <Shield className="w-3.5 h-3.5" /> KVKK Aydınlatma Metni
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-4 md:px-8 mt-8 pt-6 border-t border-stone-100 text-[11px] text-stone-500 flex flex-wrap gap-2 justify-between">
        <div>© {new Date().getFullYear()} {COMPANY.name} — Tüm hakları saklıdır.</div>
        <div>{COMPANY.brand} bir SaaS ürünüdür.</div>
      </div>
    </footer>
  );
}
